export default __webpack_public_path__ + "static/mobile-debeb4b6f4e40d2d740be79e750586af.svg";